<div class="search-div">
  <p-iconfield iconPosition="right">
    <input
      type="text"
      pInputText
      placeholder="Search"
      autocomplete="off"
      [(ngModel)]="searchKey"
      (ngModelChange)="onChange()" />
    <p-inputicon
      *ngIf="searchKey"
      class="pi pi-times input-end-icon ripple-grey"
      pRipple
      role="button"
      tabindex="0"
      aria-label="Clear search"
      (click)="onSearchClear()"
      (keydown.enter)="onSearchClear()"
      (keydown.space)="onSearchClear()">
    </p-inputicon>
  </p-iconfield>
  <button mat-raised-button aria-label="Cancel" (click)="endEditMode()" *ngIf="isEditMode && !postEditLoading">
    <mat-icon>cancel</mat-icon>Cancel
  </button>
  <button
    id="inline-save-btn"
    mat-raised-button
    [attr.aria-label]="isEditMode ? 'Save' : 'Edit Data'"
    (click)="isEditMode ? onSamplesEditCommit() : onSamplesEdit()"
    [disabled]="isEditButtonDisabled()"
    *ngIf="isEditButtonDisplayed()">
    <ng-container *ngIf="!isEditMode"><mat-icon>edit</mat-icon>Edit Data</ng-container>
    <ng-container *ngIf="isEditMode"><mat-icon>save</mat-icon>Save</ng-container>
  </button>
  <span class="notification-msg-box" *ngIf="isEditMode && !postEditLoading">
    ** Currently in Edit mode, don't forget to Save! **
  </span>

  <div class="progress-bar-container" *ngIf="apiService.isLoading$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="separator"></div>

  <div *ngIf="currentExperiment?.studyType != StudyType.ImportExcel">
    <div class="header-actions">
      <mat-icon
        *ngIf="!(apiService.isLoading$ | async)"
        class="audit-count-icon"
        [class.disabled]="isEditMode"
        matTooltip="{{ samplesAuditCountMap && samplesAuditCountMap[0] }} change log record(s)"
        matBadgeColor="warn"
        (click)="!isEditMode && showColumnAuditDialog()">
        receipt_long
      </mat-icon>
    </div>
  </div>
</div>

<div class="table-container mat-elevation-z1" [ngClass]="{'edit-mode' : isEditMode}">
  <!-- Import excel and legacy samples table view  -->
  <mat-table [dataSource]="listData" matSort  *ngIf="currentExperiment?.studyType == null || currentExperiment?.studyType == StudyType.ImportExcel">
    <ng-container matColumnDef="label">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Label</mat-header-cell>
      <mat-cell *matCellDef="let element; let rowIndex = index">
        <ng-container *ngIf="element.id > 0">{{ element.label }}</ng-container>
        <ng-container *ngIf="element.id <= 0"
          >S{{ (+newestSampleLabel + (rowIndex - newestRowIndex)).toString().padStart(2, '0') }}</ng-container
        >
      </mat-cell>
    </ng-container>

    <!-- this is a repeating container for dynamic columns, repeat for all in propertyNames, because of the *ngFor -->
    <ng-container *ngFor="let disCol of propertyNames; let colIndex = index" matColumnDef="data.{{ disCol }}">
      <mat-header-cell *matHeaderCellDef [ngClass]="{ 'cell-edit-mode': isEditMode }" >
        <div class="table-header-container">
          <ng-container *ngIf="(!isEditMode || unsavedColumns.includes(disCol)) && !(apiService.isLoading$ | async)">{{ disCol }}</ng-container>
          <div *ngIf="isEditMode && !(apiService.isLoading$ | async) && !unsavedColumns.includes(disCol)">
            <div
              class="current-value"
              [matTooltip]="disCol"
              matTooltipPositionAtOrigin="true"
              matTooltipPosition="above"
              [ngClass]="{ modified: disCol != newPropertyNames[disCol] }">
              {{ disCol }}
            </div>
            <div
              class="new-value"
              [ngClass]="{
                empty: !newPropertyNames[disCol],
                modified: disCol != newPropertyNames[disCol],
                'required-field': !newPropertyNames[disCol]
              }">
              <input
                matInput
                class="modifiable-input"
                [(ngModel)]="newPropertyNames[disCol]"
                (keydown)="onInputKeyDown($event)" />
            </div>
          </div>
          <button
            mat-icon-button
            class="remove-column-btn"
            (click)="removeColumn(disCol)"
            matTooltip="Remove Sample Column"
            *ngIf="isEditMode && unsavedColumns.includes(disCol) && !(apiService.isLoading$ | async)">
            <mat-icon class="material-icons-outlined">indeterminate_check_box</mat-icon>
          </button>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let rowIndex = index" [ngClass]="{ 'cell-edit-mode': isEditMode }">
        <ng-container *ngIf="!isEditMode">{{ element.data[disCol] }}</ng-container>
        <ng-container *ngIf="isEditMode">
          <div
            class="current-value"
            [matTooltip]="element.data[disCol]"
            matTooltipPositionAtOrigin="true"
            matTooltipPosition="above"
            [ngClass]="{ modified: element.data[disCol] != modifiedListData[element.id].data[disCol] }">
            {{ !!element.data[disCol] ? element.data[disCol] : '&nbsp;' }}
          </div>
          <div
            class="new-value"
            [ngClass]="{
              empty: !modifiedListData[element.id].data[disCol],
              modified: element.data[disCol] != modifiedListData[element.id].data[disCol]
            }">
            <input
              matInput
              class="modifiable-input"
              [(ngModel)]="modifiedListData[element.id].data[disCol]"
              (keydown)="onInputKeyDown($event)" />
          </div>
        </ng-container>
      </mat-cell>
    </ng-container>
    <!-- *************************************** -->

    <ng-container matColumnDef="unevaluable">
      <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode">
        <span *ngIf="!isEditMode">Ignore</span>
        <span *ngIf="isEditMode  && !(apiService.isLoading$ | async)">
          <button
            mat-icon-button
            class="add-column-btn"
            (click)="addColumn()"
            matTooltip="Add Sample Column"
            *ngIf="isEditMode">
            <mat-icon class="material-icons-outlined">add_box</mat-icon>
          </button>
        </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-checkbox
          [disabled]="
            !(currentRoles | hasAnyRoles : ['READER', 'WRITER'] : currentExperiment : 'IsReadyToTest') ||
            (currentExperiment | statusIsNot : ['ReadyToTest']) ||
            isEditMode
          "
          [checked]="element.unevaluable"
          (change)="$event ? toggleSampleUnevaluable(element, $event) : null"
          *ngIf="!isEditMode">
        </mat-checkbox>
        <button
          mat-icon-button
          (click)="duplicateRow(modifiedListData[element.id])"
          matTooltip="Duplicate Sample"
          *ngIf="isEditMode">
          <mat-icon>add</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="removeRow(element)"
          matTooltip="Remove Sample"
          *ngIf="isEditMode && element.id < 0">
          <mat-icon>remove</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>
        <div class="header-actions">
          <mat-icon
            *ngIf="!(apiService.isLoading$ | async)"
            class="audit-count-icon"
            [class.disabled]="isEditMode"
            matTooltip="{{ samplesAuditCountMap && samplesAuditCountMap[0] }} change log record(s)"
            matBadgeColor="warn"
            (click)="!isEditMode && showColumnAuditDialog()">
            receipt_long
          </mat-icon>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button
          mat-icon-button
          matTooltip="Delete sample and related details"
          (click)="onDelete(row)"
          [disabled]="
            !(currentRoles | hasAnyRoles : ['WRITER'] : currentExperiment : 'IsLessThanReadyToTest') ||
            isEditMode ||
            ((currentExperiment | statusIs : ['ReadyToTest']) && listData.data.length == 1)
          ">
          <mat-icon>delete</mat-icon>
        </button>
        <app-note-display
          [experimentId]="experimentId"
          [noteCount]="samplesNotesCountMap && samplesNotesCountMap[row.id]"
          [objectID]="row.id"
          [objectName]="objectName"
          [isEditMode]="isEditMode">
        </app-note-display>
        <mat-icon
          *ngIf="samplesAuditCountMap && samplesAuditCountMap[row.id] > 0"
          class="audit-count-icon"
          [class.disabled]="isEditMode"
          matTooltip="{{ samplesAuditCountMap && samplesAuditCountMap[row.id] }} change log records"
          matBadgeColor="warn"
          (click)="!isEditMode && showAuditDialog(row)">
          receipt_long
        </mat-icon>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="6"> Loading data... </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="6"> No data. </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: listData != null }"></mat-footer-row>
    <mat-footer-row
      *matFooterRowDef="['noData']"
      [ngClass]="{ hide: !(listData != null && listData.data.length == 0) }">
    </mat-footer-row>
  </mat-table>
  <!-- Other study types samples view -->
  <div id="samples-container" class="samples-container" *ngIf="currentExperiment?.studyType != null && currentExperiment?.studyType != StudyType.ImportExcel">
    <!-- Samples, iterating -->
    <mat-accordion [id]="'sample-'+element.id" *ngFor="let element of getFilteredAndPagedData(); let rowIndex = index">
      <mat-expansion-panel hideToggle [expanded]="isEditMode">
        <mat-expansion-panel-header [collapsedHeight]=" isEditMode ? '96px' : '70px'" [expandedHeight]="isEditMode ? '96px' : '70px'" #panelH (click)="panelH._toggle()" (keydown.Space)="$event.stopImmediatePropagation();">
          <mat-panel-title class="panel-title" (keydown.Space)="$event.stopPropagation()"> 
            <!-- Sample, Iterating over the static columns -->
            <div class="dynamic-column" *ngFor="let disCol of staticColumns; let colIndex = index">
                <div [ngClass]="{ 'cell-edit-mode': isEditMode }">
                  <div class="header-container" [matTooltip]="disCol.header + (disCol.required ? '*' : '')">
                    <span>
                      {{disCol.header}}<span *ngIf="disCol.required" class="required">*</span>
                    </span>
                  </div>
                  <div class="value-container" *ngIf="!isEditMode">
                    <span *ngIf="!disCol.isCustom" [matTooltip]="element[disCol.prop]">
                      {{ element[disCol.prop] }}
                    </span>
                    <span *ngIf="disCol.isCustom && disCol.prop === 'externalControlType'" [matTooltip]="element[disCol.prop] === 'false' ? 'Negative' : 'Positive'">
                      {{ element[disCol.prop] === 'false' ? 'Negative' : 'Positive'}}
                    </span>
                  </div>
                  <ng-container *ngIf="isEditMode">
                    <div
                      class="current-value"
                      [ngClass]="{ modified: element[disCol.prop] != modifiedListData[element.id][disCol.prop] }">
                      <span *ngIf="!disCol.isCustom" [matTooltip]="!!element[disCol.prop] ? element[disCol.prop] : '&nbsp;'">
                        {{ !!element[disCol.prop] ? element[disCol.prop] : '&nbsp;' }}
                      </span>
                      <span *ngIf="disCol.isCustom && disCol.prop === 'externalControlType'" [matTooltip]="element[disCol.prop] === 'false' ? 'Negative' : 'Positive'">
                        {{ element[disCol.prop] === 'false' ? 'Negative' : 'Positive'}}
                      </span>
                    </div>
                    <div
                      class="new-value"
                      [ngClass]="{
                        empty: !modifiedListData[element.id][disCol.prop],
                        modified: element[disCol.prop] != modifiedListData[element.id][disCol.prop],
                        'required-field': disCol.required && !modifiedListData[element.id][disCol.prop]
                      }">
                      <input
                        *ngIf="!disCol.inputType && !disCol.isCustom"
                        matInput
                        class="modifiable-input"
                        [(ngModel)]="modifiedListData[element.id][disCol.prop]"
                        (keydown)="onInputKeyDown($event)" />
                      <input
                        *ngIf="disCol.inputType === 'number' && !disCol.isCustom"
                        type="number"
                        matInput
                        class="modifiable-input"
                        [(ngModel)]="modifiedListData[element.id][disCol.prop]"
                        (keydown)="onInputKeyDown($event)" />
                      <select *ngIf="disCol.isCustom && disCol.prop === 'externalControlType'" [(ngModel)]="modifiedListData[element.id][disCol.prop]">
                        <option value="false">Negative</option>
                        <option value="true">Postive</option>
                      </select>
                    </div>
                  </ng-container>
                </div>
            </div>
            <!-- Sample, Iterating over the dynamic columns -->
            <div class="dynamic-column" *ngFor="let disCol of propertyNames; let colIndex = index">
              <div [ngClass]="{ 'cell-edit-mode': isEditMode }" >
                <div class="header-container">
                  <ng-container *ngIf="(!isEditMode || unsavedColumns.includes(disCol)) && !(apiService.isLoading$ | async)">
                    <span [matTooltip]="disCol">{{ disCol }}</span>
                  </ng-container>
                  <div class="w-100" *ngIf="isEditMode && !(apiService.isLoading$ | async) && !unsavedColumns.includes(disCol)">
                    <div
                      class="current-value"
                      [matTooltip]="disCol"
                      matTooltipPositionAtOrigin="true"
                      matTooltipPosition="above"
                      [ngClass]="{ modified: disCol != newPropertyNames[disCol] }">
                      {{ disCol }}
                    </div>
                    <div
                      class="new-value"
                      [ngClass]="{
                        empty: !newPropertyNames[disCol],
                        modified: disCol != newPropertyNames[disCol],
                        'required-field': !newPropertyNames[disCol]
                      }">
                      <input
                        matInput
                        class="modifiable-input"
                        [(ngModel)]="newPropertyNames[disCol]"
                        (keydown)="onInputKeyDown($event)" />
                    </div>
                  </div>
                  <button
                    mat-icon-button
                    class="remove-column-btn"
                    (click)="removeColumn(disCol)"
                    matTooltip="Remove Sample Column"
                    *ngIf="isEditMode && unsavedColumns.includes(disCol) && !(apiService.isLoading$ | async)">
                    <mat-icon class="material-icons-outlined">indeterminate_check_box</mat-icon>
                  </button>
                </div>
              </div>
              <div [ngClass]="{ 'cell-edit-mode': isEditMode }">
                <div class="value-container" *ngIf="!isEditMode">{{ element.data[disCol] }}</div>
                <ng-container *ngIf="isEditMode">
                  <div
                    class="current-value"
                    [matTooltip]="element.data[disCol]"
                    matTooltipPositionAtOrigin="true"
                    matTooltipPosition="above"
                    [ngClass]="{ modified: element.data[disCol] != modifiedListData[element.id].data[disCol] }">
                    {{ !!element.data[disCol] ? element.data[disCol] : '&nbsp;' }}
                  </div>
                  <div
                    class="new-value"
                    [ngClass]="{
                      empty: !modifiedListData[element.id].data[disCol],
                      modified: element.data[disCol] != modifiedListData[element.id].data[disCol]
                    }">
                    <input
                      matInput
                      class="modifiable-input"
                      [(ngModel)]="modifiedListData[element.id].data[disCol]"
                      (keydown)="onInputKeyDown($event)" />
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- Sample add column -->
            <span *ngIf="isEditMode  && !(apiService.isLoading$ | async)">
              <button
                mat-icon-button
                class="add-column-btn"
                (click)="addColumn()"
                matTooltip="Add Sample Column"
                [style.visibility]="isEditMode && rowIndex == 0 ? 'visible': 'hidden'">
                <mat-icon class="material-icons-outlined">add_box</mat-icon>
              </button>
            </span>
            <div class="separator"></div>
            <!-- Sample actions -->
            <div class="actions">
              <!-- Ignore sample checkbox -->
              <div class="unevaluable-container" *ngIf="!isEditMode">
                <div class="header-container">Ignore</div>
                <mat-checkbox
                  class="action-button"
                  [disabled]="
                    !(currentRoles | hasAnyRoles : ['READER', 'WRITER'] : currentExperiment : 'IsReadyToTest') ||
                    (currentExperiment | statusIsNot : ['ReadyToTest']) ||
                    isEditMode
                  "
                  [checked]="element.unevaluable"
                  (change)="$event ? toggleSampleUnevaluable(element, $event) : null"
                  >
                </mat-checkbox>
              </div>
              <!-- Duplicate sample row -->
              <button
                class="action-button"
                mat-icon-button
                (click)="duplicateRow(modifiedListData[element.id])"
                matTooltip="Duplicate Sample"
                *ngIf="isEditMode">
                <mat-icon>add</mat-icon>
              </button>
              <!-- Remove sample row -->
              <button
                class="action-button"
                mat-icon-button
                (click)="removeRow(element)"
                matTooltip="Remove Sample"
                [style.visibility]="isEditMode && element.id < 0 ? 'visible': 'hidden'"
                *ngIf="isEditMode">
                <mat-icon>remove</mat-icon>
              </button>
              <!-- Sample delete button -->
              <button
                mat-icon-button
                class="action-button"
                matTooltip="Delete sample and related details"
                (click)="onDelete(element)"
                *ngIf="!isEditMode"
                [disabled]="
                  !(currentRoles | hasAnyRoles : ['WRITER'] : currentExperiment : 'IsLessThanReadyToTest') ||
                  isEditMode ||
                  ((currentExperiment | statusIs : ['ReadyToTest']) && listData.data.length == 1)
                ">
                <mat-icon>delete</mat-icon>
              </button>
              <!-- Sample notes -->
              <app-note-display
                class="action-button"
                *ngIf="!isEditMode"
                [experimentId]="experimentId"
                [noteCount]="samplesNotesCountMap && samplesNotesCountMap[element.id]"
                [objectID]="element.id"
                [objectName]="objectName"
                [isEditMode]="isEditMode">
              </app-note-display>
              <!-- Sample logs  -->
              <button
                class="action-button"
                mat-icon-button
                [style.visibility]="samplesAuditCountMap && samplesAuditCountMap[element.id] > 0 ? 'visible': 'hidden'"
                *ngIf="!isEditMode"
                [class.disabled]="isEditMode"
                matTooltip="{{ samplesAuditCountMap && samplesAuditCountMap[element.id] }} change log records"
                matBadgeColor="warn"
                (click)="!isEditMode && showAuditDialog(element)">
                <mat-icon>receipt_long</mat-icon>
              </button>
              <!-- Toggle analytes button -->
              <div 
                class="action-button"
                *ngIf="!isEditMode && shouldShowAnalytes()"> 
                <button
                  mat-icon-button
                  *ngIf="panelH._isExpanded()"
                  (click)="panelH._toggle()">
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button
                  mat-icon-button
                  *ngIf="!panelH._isExpanded()"
                  (click)="panelH._toggle()">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="analytes-container" *ngIf="shouldShowAnalytes()">
          <!-- Analytes -->
          <ng-container *ngFor="let analyte of element.analytes; let analyteRowIndex = index">
            <div *ngIf="analyteRowIndex !== 0" class="separator-analyte"></div>
            <div class="analyte-container" [id]="'analyte-'+analyte.analyteId">
              <!-- Analyte: static columns -->
              <div class="dynamic-column" *ngFor="let analyteCol of staticAnalyteColumns; let analyteColIndex = index">
                <div [ngClass]="{ 'cell-edit-mode': isEditMode }">
                  <div class="header-container" [matTooltip]="analyteCol.header + (analyteCol.required ? '*' : '')">
                    <span>
                      {{analyteCol.header}}
                      <span *ngIf="analyteCol.required" class="required">*</span>
                    </span>
                  </div>
                  <div class="value-container" *ngIf="!isEditMode">
                    <span *ngIf="!analyteCol.isCustom" [matTooltip]="analyte[analyteCol.prop]">
                      {{ analyte[analyteCol.prop] }}
                    </span>
                    <span *ngIf="analyteCol.isCustom && analyteCol.valueType === 'scientific'" [matTooltip]="toScientificNotation(analyte[analyteCol.prop])+''">
                      {{ toScientificNotation(analyte[analyteCol.prop]) }}
                    </span>
                    <span *ngIf="analyteCol.isCustom && analyteCol.inputType === 'select'" [matTooltip]="getSelectValue(analyteCol, analyte)">
                      {{ getSelectValue(analyteCol, analyte) }}
                    </span>
                  </div>
                  <!-- Analytes: static columns edit mode -->
                  <ng-container *ngIf="isEditMode">
                    <div
                      class="current-value"
                      [matTooltip]="analyte[analyteCol.prop]"
                      matTooltipPositionAtOrigin="true"
                      matTooltipPosition="above"
                      [ngClass]="{ modified: analyte[analyteCol.prop] != modifiedListData[element.id].analytes[analyteRowIndex][analyteCol.prop] }">
                      <span *ngIf="!analyteCol.isCustom">
                        {{ !!analyte[analyteCol.prop] ? analyte[analyteCol.prop] : '&nbsp;' }}
                      </span>
                      <span *ngIf="analyteCol.isCustom && analyteCol.valueType === 'scientific'">
                        {{ !!analyte[analyteCol.prop] ? toScientificNotation(analyte[analyteCol.prop]) : '&nbsp;' }}
                      </span>
                      <span *ngIf="analyteCol.isCustom && analyteCol.inputType === 'select' && analyteCol.prop !== 'analyteTemplateId'">
                        {{ getSelectValue(analyteCol, analyte) }}
                      </span>
                      &nbsp;
                    </div>
                    <div
                      class="new-value"
                      [ngClass]="{
                        empty: !modifiedListData[element.id].analytes[analyteRowIndex][analyteCol.prop],
                        modified: analyte[analyteCol.prop] != modifiedListData[element.id].analytes[analyteRowIndex][analyteCol.prop],
                        'required-field': isAnalyteColumnInvalid(analyteCol, element, analyteRowIndex)
                      }">
                      <input
                        *ngIf="!analyteCol.inputType"
                        matInput
                        class="modifiable-input"
                        [(ngModel)]="modifiedListData[element.id].analytes[analyteRowIndex][analyteCol.prop]"
                        (keydown)="onInputKeyDown($event)" />
                      <input
                        *ngIf="analyteCol.inputType && analyteCol.inputType === 'number'"
                        type="number"
                        matInput
                        class="modifiable-input"
                        [(ngModel)]="modifiedListData[element.id].analytes[analyteRowIndex][analyteCol.prop]"
                        (keydown)="onInputKeyDown($event)"
                        [min]="analyteCol.minValue" />
                      <select 
                        *ngIf="analyteCol.isCustom && analyteCol.inputType === 'select'" [(ngModel)]="modifiedListData[element.id].analytes[analyteRowIndex][analyteCol.prop]">
                        <option [value]="o.value" *ngFor="let o of analyteCol.options">{{o.label}}</option>
                      </select>
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- Analyte: dynamic columns -->
              <div class="dynamic-column" *ngFor="let disCol of analytePropertyNames; let analyteColIndex = index">
                <div [ngClass]="{ 'cell-edit-mode': isEditMode }" >
                  <div class="header-container">
                    <ng-container *ngIf="(!isEditMode || analyteUnsavedColumns.includes(disCol)) && !(apiService.isLoading$ | async)">
                      <span [matTooltip]="disCol">
                        {{ disCol }}
                      </span>
                    </ng-container>
                    <div class="w-100" *ngIf="isEditMode && !(apiService.isLoading$ | async) && !analyteUnsavedColumns.includes(disCol)">
                      <div
                        class="current-value"
                        [matTooltip]="disCol"
                        matTooltipPositionAtOrigin="true"
                        matTooltipPosition="above"
                        [ngClass]="{ modified: disCol != analyteNewPropertyNames[disCol] }">
                        {{ disCol }}
                      </div>
                      <div
                        class="new-value"
                        [ngClass]="{
                          empty: !analyteNewPropertyNames[disCol],
                          modified: disCol != analyteNewPropertyNames[disCol],
                          'required-field': !analyteNewPropertyNames[disCol]
                        }">
                        <input
                          matInput
                          class="modifiable-input"
                          [(ngModel)]="analyteNewPropertyNames[disCol]"
                          (keydown)="onInputKeyDown($event)" />
                      </div>
                    </div>
                    <button
                      mat-icon-button
                      class="remove-column-btn"
                      (click)="removeAnalyteColumn(disCol)"
                      matTooltip="Remove Analyte Column"
                      *ngIf="isEditMode && analyteUnsavedColumns.includes(disCol) && !(apiService.isLoading$ | async)">
                      <mat-icon class="material-icons-outlined">indeterminate_check_box</mat-icon>
                    </button>
                  </div>
                </div>
                <div [ngClass]="{ 'cell-edit-mode': isEditMode }">
                  <div class="value-container" *ngIf="!isEditMode">{{ analyte.data[disCol] }}</div>
                  <ng-container *ngIf="isEditMode">
                    <div
                      class="current-value"
                      [matTooltip]="!!analyte.data[disCol] ? analyte.data[disCol] : '&nbsp;'"
                      matTooltipPositionAtOrigin="true"
                      matTooltipPosition="above"
                      [ngClass]="{ modified: analyte.data[disCol] != modifiedListData[element.id].analytes[analyteRowIndex].data[disCol] }">
                      {{ !!analyte.data[disCol] ? analyte.data[disCol] : '&nbsp;' }}
                    </div>
                    <div
                      class="new-value"
                      [ngClass]="{
                        empty: !modifiedListData[element.id].analytes[analyteRowIndex].data[disCol],
                        modified: analyte.data[disCol] != modifiedListData[element.id].analytes[analyteRowIndex].data[disCol]
                      }">
                      <input
                        matInput
                        class="modifiable-input"
                        [(ngModel)]="modifiedListData[element.id].analytes[analyteRowIndex].data[disCol]"
                        (keydown)="onInputKeyDown($event)" />
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- Analyte: add column -->
              <span *ngIf="isEditMode  && !(apiService.isLoading$ | async)">
                <button
                  mat-icon-button
                  class="add-column-btn"
                  (click)="addAnalyteColumn(analyte)"
                  matTooltip="Add Analyte Column"
                  [style.visibility]="analyteRowIndex !== 0 ? 'hidden': 'visible'">
                  <mat-icon class="material-icons-outlined">add_box</mat-icon>
                </button>
              </span>
              <div class="separator"></div>
              <!-- Analyte: actions -->
              <div class="actions">
                <!-- Analyte: duplicate analyte -->
                <button
                  class="action-button"
                  mat-icon-button
                  (click)="duplicateAnalyte(element.id, modifiedListData[element.id].analytes[analyteRowIndex])"
                  matTooltip="Duplicate Analyte"
                  *ngIf="isEditMode">
                  <mat-icon>add</mat-icon>
                </button>
                <!-- Analyte: remove analyte row -->
                <button
                  class="action-button"
                  mat-icon-button
                  (click)="removeAnalyte(element.id, analyteRowIndex)"
                  matTooltip="Remove Analyte"
                  [style.visibility]="isEditMode && element.analytes[analyteRowIndex].analyteId < 0? 'visible': 'hidden'">
                  <mat-icon>remove</mat-icon>
                </button>
                <!-- Analyte: delete analyte -->
                <button
                  class="action-button"
                  mat-icon-button
                  matTooltip="Delete analyte"
                  (click)="onDeleteAnalyte(element, element.analytes[analyteRowIndex])"
                  *ngIf="!isEditMode"
                  [disabled]="
                    !(currentRoles | hasAnyRoles : ['WRITER'] : currentExperiment : 'IsLessThanReadyToTest') ||
                    isEditMode ||
                    ((currentExperiment | statusIs : ['ReadyToTest']) && listData.data.length == 1)
                  ">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
          
          <div class="edit-mode-add-row" *ngIf="isEditMode && !postEditLoading && shouldShowAnalytes()">
            <button
              mat-raised-button
              aria-label="Append New Analyte"
              (click)="appendNewAnalyte(element.id, null)"
              >
              <mat-icon>add</mat-icon>
              Append New Analyte
            </button>
          </div>
        </div>
        
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
<mat-paginator
  class="mat-elevation-z1"
  [pageSizeOptions]="[5, 10, 25, 100]"
  [pageSize]="10"
  showFirstLastButtons
  [style.display]="isEditMode ? 'none' : 'block'">
</mat-paginator>
<div class="edit-mode-add-row mat-elevation-z1" *ngIf="isEditMode && !postEditLoading">
  <button
    mat-raised-button
    aria-label="Append New Row"
    (click)="appendNewRow()">
    <mat-icon>add</mat-icon>
    Append New Sample
  </button>
</div>


